export default __webpack_public_path__ + "static/media/PaidPending.db1617e8.svg";